import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GuiService } from '../_services/gui-service/gui.service';
import { InitialNotificationsService } from '../_services/initial-notifications/initial-notifications.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AutoExecutor } from '../_models/auto-executor';
import { TopologyList, TopologyWithRoot } from '../_models/topology-list';
import { MapService } from '../_services/map/map.service';
import { ViolationResultsAutoExecutor } from '../_models/violation-results-auto-executor';

@Component({
  selector: 'app-initial-notifications',
  templateUrl: './initial-notifications.component.html',
  styleUrls: ['./initial-notifications.component.css']
})
export class InitialNotificationsComponent implements OnInit {

  public initialNotificationsTitle: string;
  public autoExecutorMessage: AutoExecutor;
  public listOfTopologies: TopologyList;
  public updatedListOfViolationResults: Array<ViolationResultsAutoExecutor> = [];

  constructor(
    public activeModal: NgbActiveModal,
    private guiService: GuiService,
    private initialNotificationsService: InitialNotificationsService,
    private mapService: MapService,
  ) { }

  ngOnInit() {
    this.initialNotificationsTitle = this.initialNotificationsService.getInitialNotificationTitle();
    this.autoExecutorMessage = this.initialNotificationsService.getAutoExecutorMessage();

    
    try {
      const topologies = localStorage.getItem('topologies');
      if (topologies) {
        this.listOfTopologies = JSON.parse(topologies);
        console.log('Topologies retrieved from localStorage:', this.listOfTopologies);
      } else {
        this.mapService.getAvailableTopologies().subscribe((response: TopologyList) => {
          this.listOfTopologies = response;
          localStorage.setItem('topologies', JSON.stringify(this.listOfTopologies));
          console.log('Topologies fetched from the API and stored in localStorage:', this.listOfTopologies);
        });
      }
    } catch (error) {
      console.error('Error retrieving topologies from localStorage:', error);
      this.mapService.getAvailableTopologies().subscribe((response: TopologyList) => {
        this.listOfTopologies = response;
        localStorage.setItem('topologies', JSON.stringify(this.listOfTopologies));
      });
    }
  }

  doNotShowAgain(){
    this.guiService.getDoNotShowNotifications(this.initialNotificationsService.getNotificationId()).subscribe((response) => {
      console.error(JSON.parse(response));
    });
    this.activeModal.close('close');
  }

  chechIfNotificationIsNotNull(){
    if(this.autoExecutorMessage.failedTopologies.length == 0 && this.autoExecutorMessage.violationResults.length == 0){
      return true;
    }
    return false;
  }

  public updateListOfViolationResults(violationResults: Array<ViolationResultsAutoExecutor>): Array<ViolationResultsAutoExecutor> {
    this.updatedListOfViolationResults = [];
    violationResults.forEach((violationResults: ViolationResultsAutoExecutor) => {
      this.listOfTopologies.topologiesWithRoots.forEach((topology: TopologyWithRoot) => {
        if(violationResults.topologyId === topology.TopologyId){
          this.updatedListOfViolationResults.push({
            topologyId: topology.displayName ? topology.displayName : topology.internalDsoId + " - " + topology.TopologyId,
            trafoLoadViolationCount: violationResults.trafoLoadViolationCount,
            lineLoadViolationCount: violationResults.lineLoadViolationCount,
            trafoVoltageViolationCount: violationResults.trafoVoltageViolationCount
          });
        }
      });
    });
    return this.updatedListOfViolationResults;
  }

  getListOfFailedTopolgies(failedTopologies: Array<String>): Array<String> {
    let listOfFailedTopologies: Array<String> = [];
    failedTopologies.forEach((topologyId: string) => {
      this.listOfTopologies.topologiesWithRoots.forEach((topology: TopologyWithRoot) => {
        if(topology.TopologyId === topologyId){
          listOfFailedTopologies.push(topology.displayName ? topology.displayName : topology.internalDsoId + " - " + topology.TopologyId);
        }
      })
    });
    return listOfFailedTopologies;
  }
}
